import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { 
    Box, 
} from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';

import LogoAmex from "../../assets/img/logo_amex.png";
import LogoDinner from "../../assets/img/logo_dinners.png";
import LogoPayu from "../../assets/img/logo_payu.png";
import LogoVisa from "../../assets/img/logo_visa.png";

import QuantitySelector from "../QuantitySelector";
import { CartContext } from "../../context/CartContext";

import { formatNumber } from "../../utils/formatNumber";

import "../../assets/img/Cart/Cart.css";

const Cart = ({
    isOpenCart, 
    openCart
}) => {
    const navigate = useNavigate();
    const { cartItems, updateQuantity, removeFromCart } = useContext(CartContext);
    const totalPrice = cartItems.reduce((total, item) => total + item.quantity * item.price, 0);

    const groupedItems = cartItems.reduce((acc, item) => {
        const seller = item.seller;
        if (!acc[seller]) {
            acc[seller] = [];
        }
        acc[seller].push(item);
        return acc;
    }, {});

    const totalPriceShipping = Object.entries(groupedItems).map(([seller, items]) => 
        items.reduce((sum, item) => sum + item.priceShipping, 0)
    );
    const grandTotalShipping = totalPriceShipping.reduce((sum, price) => sum + price, 0);

    return (
        <Box className={`cart ${isOpenCart ? "active" : ""}`}>
            <Box className="cart-content">
                <div className="cart-header">
                    <h2>Mi carrito</h2>
                    <CloseIcon onClick={openCart} className="btn-close-cart" />
                </div>

                {cartItems.length > 0 ? (
                    <div key={"cart-content-0"} className='d-flex content-mobile justify-content-between flex-column flex-lg-row px-4 gap-4 mt-5'>
                        <div className="cart-items">
                            {Object.entries(groupedItems).map(([seller, items], index) => (
                                <div key={"seller-package-" + index} className='w-100'>
                                    <h4>Paquete {index + 1}</h4>
                                    {items.map((item) => (
                                        <div key={"item-product-" + item.uid} className='cart-item'>
                                            <div className="item-image">
                                                <img src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${item.image}`} alt={item.title} />
                                            </div>
                                            <div className="item-details w-100">
                                                <div className="d-flex justify-content-between">
                                                    <p>{item.title}</p>

                                                    <button 
                                                        className="btn px-2 py-0 btn-delete-cart d-md-none" 
                                                        type="button" 
                                                        onClick={() => removeFromCart(item.uid)}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                            <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-start mt-4 gap-md-5 gap-1">
                                                    <span className="item-price">${formatNumber(item.quantity * item.price)}</span>

                                                    <div className="d-flex">
                                                        <QuantitySelector 
                                                            spacing="py-1"
                                                            onQuantityChange={(value) => updateQuantity(item.uid, value)} 
                                                            initialQuantity={item.quantity} 
                                                        />

                                                        <button 
                                                            className="btn px-2 py-0 btn-delete-cart d-md-block d-none" 
                                                            type="button" 
                                                            onClick={() => removeFromCart(item.uid)}
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                                                <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div className="cart-summary">
                            <h3 className="m-0 d-md-block d-none">Resumen del carrito</h3>

                            <div className="my-4 d-md-block d-none border-bottom pb-4">
                                <div className="summary-item">
                                    <span>Subtotal:</span>
                                    <span>${formatNumber(totalPrice)}</span>
                                </div>
                                {Object.entries(groupedItems).map(([_seller, items], index) => {
                                    const totalShipping = items.reduce((sum, item) => sum + item.priceShipping, 0);

                                    return (
                                        <div className="summary-item" key={index}>
                                            <span>Envío paquete {index + 1}:</span>
                                            <span>$ {formatNumber(totalShipping)}</span>
                                        </div>
                                    );
                                })}
                                
                            </div>

                            <div>
                                <div className="summary-total">
                                    <span>Total con envío:</span>
                                    <span>${formatNumber(totalPrice + grandTotalShipping)}</span>
                                </div>

                                <button onClick={() => navigate("/checkout")} style={{
                                    maxWidth: "100%"
                                }} className="buy-button my-4 w-100">Continuar con el pedido</button>
                            </div>
                            
                            <div className="cart-footer d-md-block d-none">
                                <p>Todos los medios de pago:</p>
                                <div className="d-flex justify-content-start">
                                    <div className="payment-methods mx-auto mt-2">
                                        <img src={LogoPayu} alt="PayU" />
                                        <img src={LogoVisa} alt="Visa" />
                                        <img src={LogoDinner} alt="Dinner" />
                                        <img src={LogoAmex} alt="American Express" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ):(
                    <div className="empty-cart w-100 text-center d-flex flex-column justify-content-center align-items-center my-5">
                        <h3>Tu carrito está vacío</h3>
                        <p>Agrega productos para ver el resumen de tu compra.</p>
                    </div>                    
                )}
            </Box>
        </Box>
    );
}

export default Cart;